export { toChecksumAddress } from 'ethereum-checksum-address'

export const sleep = (ms) => {
  console.info(`Sleeping for ${ms}ms`)
  return new Promise((resolve) => setTimeout(resolve, ms))
}
export const toShortAddress = (a) => a && `${a.substr(0, 6)}...${a.substr(a.length - 4)}`
export const getCID = (str) => {
  const regex = /Qm[a-zA-Z1-9]{44}/
  return regex.test(`${str}`) ? `${str}`.match(regex).pop() : ''
}
export const lowercaseObjectID = (objId) => {
  const parts = objId.split(':')
  return `${parts[0]}:${parts[1].toLowerCase()}:${parts[2].toLowerCase()}`
}
export const extractAddress = (str) => (str ? str.split(':').pop() : null)

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})
export const formatUSD = usdFormatter.format

// https://www.notion.so/eboweb3/6fe0d2ecf6d745d683c3efcc76bcd43c?v=678462c9e2e144f890a6a9289845ceb3
export const defaultTokens = [
  'ETH',
  'WBTC',
  'UNI',
  'AAVE',
  'BAT',
  'LINK',
  'COMP',
  'CRV',
  'MKR',
  'SNX',
  'UMA',
  'YFI',
  'DAI',
  'RAI',
  'USDC',
  'USDT',
  'GUSD',
  'PAX',
]

export const uid = () => Math.random().toString().slice(2) // Only unique within current session
export const getLocalTime = (isoString) =>
  new Date(isoString).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  })

export const toExplorerAddress = (address) => {
  return `https://basescan.org/address/${address}`
}